module.exports = __webpack_public_path__ + "img/empty.d49e0cf2.png";